import script from "./FarmaciPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./FarmaciPage.vue?vue&type=script&setup=true&lang=ts"

import "./FarmaciPage.vue?vue&type=style&index=0&id=21c0d1c3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21c0d1c3"]])

export default __exports__